import styled from 'styled-components';
import { ButtonSize, PrimaryButton } from '@prisjakt/ui/button/variants';

export const CallToActionContainer = styled.section``;

export const CallToActionButton = styled(PrimaryButton).attrs({
  fullWidth: false,
  size: ButtonSize.LARGE,
})`
  max-width: 100%;
  margin: 0 auto;
  min-width: 50%;
  text-align: center;
`;
